import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state, sequences } from 'app/pwa/app.cerebral';

import {
  Modal,
  CloseIconContainer,
  CloseIcon,
  InnerWrapper,
  TextWrapper,
  Heading,
  SubHeading,
  Text,
  Image,
  Footer,
} from './elements';
import { useText } from 'common/hooks';

const deps = {
  explanationModalShowing: state.account.timeline.explanationModalShowing,
  closeModalClicked: sequences`appContainer.closeModalClicked`,
};

type Props = {
  readonly heading: string;
  readonly subheading: string;
  readonly text: string;
  readonly image: string;
};

export function ExplanationModal({
  explanationModalShowing,
  closeModalClicked,
  heading,
  subheading,
  text,
  image,
}: Props & typeof deps & ConnectedProps): React.ReactElement {
  const t = useText();

  return (
    <Modal
      onHide={() => closeModalClicked()}
      show={Boolean(explanationModalShowing)}
    >
      <CloseIconContainer>
        <CloseIcon icon={'icon-close'} onClick={() => closeModalClicked()} />
      </CloseIconContainer>
      <InnerWrapper>
        <TextWrapper>
          <Heading>{heading}</Heading>
          <SubHeading>{subheading}</SubHeading>
          <Text>{text}</Text>
        </TextWrapper>
        <Image src={image} />
      </InnerWrapper>
      <Footer
        onClick={() => closeModalClicked()}
        text={t('challenge.GMod08.close')}
      />
    </Modal>
  );
}

export default connect<Props, typeof deps>(deps, ExplanationModal);
